<template>
  <div
    class="login-container"
    :style="{
      backgroundImage: `url(${bgMain})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: 'white'
    }"
  >
    <!-- <img :src="birdLogo" class="birdLogo" alt="" /> -->

    <div class="maxxifiedLogoContainer">
      <img :src="maxxifiedLogo" class="newLogo" alt="" />
    </div>

    <p class="loginTitleNew">{{ $t('login.title') }}</p>
    <p class="loginSuitTitleNew">{{ $t('login.subtitle') }}</p>

    <div class="login-card">
      <form @submit.prevent="handleLogin" class="login-card-inner-section">
        <custom-input :label="$t('login.username')" type="text" :placeholder="$t('login.email_placeholder')" :value="username" @update:value="username = $event" :error="errors.username" />
        <div class="inputDiv">
          <custom-input :label="$t('login.password')" type="password" :placeholder="$t('login.password_placeholder')" :value="password" @update:value="password = $event" :error="errors.password" />
        </div>

        <div class="buttonDiv">
          <custom-button :disabled="loading" @click="login">
            {{ $t('login.next') }}
            <div v-if="loading" class="spinner-border text-white spinner-grow-sm" role="status"></div>
          </custom-button>
        </div>
        <!-- <p class="forgotPasswordText">OR</p> -->
        <!-- In Login.vue -->
        <!-- <custom-button @click="$router.push('/register')">
          Go to Register
        </custom-button> -->

        <p class="forgotPasswordText" style="cursor: pointer" @click="goToForgotPassword">{{ $t('login.forgot_password') }}</p>
        <!-- <p class="termsAndConditions">
          {{ $t('login.analytics_info') }} <a class="highlightedText">{{ $t('login.cookie') }}</a> {{ $t('login.and') }}
          <a class="highlightedText">{{ $t('login.privacy_policy') }}</a>
        </p> -->
      </form>
    </div>

    <Footer />
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore'
import CustomInput from '../../components/CustomInput.vue'
import CustomButton from '../../components/CustomButton.vue'
import Footer from '../../components/Footer.vue'
import birdLogo from '@/assets/bird-logo.png'
import maxxifiedLogo from '@/assets/vasionLogin.png'
import bgMain from '@/assets/bg_main.png'

export default {
  data() {
    return {
      username: '',
      password: '',
      firstName: '',
      LastName: '',
      loading: false, // Added loading state
      message: this.$route.query.message || null,
      errors: {
        username: '',
        password: '',
      },
      birdLogo,
      maxxifiedLogo,
      bgMain,
    }
  },
  components: {
    CustomInput,
    CustomButton,
    Footer,
  },
  mounted() {
    document.title = 'Vasion IDP'
    localStorage.clear()
  },
  computed: {
    auth() {
      return useAuthStore()
    },
  },
  methods: {
    validateFields() {
      this.errors = { username: '', password: '' } // Reset errors

      if (!this.username) {
        this.errors.username = 'Please enter valid email address'
      }
      if (!this.password) {
        this.errors.password = 'Please enter valid Password'
      }

      return !this.errors.username && !this.errors.password // Return true if no errors
    },
    goToForgotPassword() {
      this.$router.push('/forgot-password')
    },
    updateValue(event) {
      this.$emit('update:value', event.target.value)
    },
    async handleLogin() {
      if (!this.validateFields()) return // Stop if validation fails
      this.loading = true
      // this.$router.push('/dashboard')

      const loginResponse = await this.auth.login(this.username, this.password)
      if (loginResponse?.data?.code === 200) {
        // Optionally check if OTP is required
        // clear store persist state here      
        this.$router.push('/otp-verification')
      } else {
        // Optionally handle error (already set in this.auth.error)
        this.errors.username = 'Please enter valid email Id'
        this.errors.password = 'Incorrect password, Please enter a valid password'
        this.loading = false
      }
      // this.loading = false
      // // if (!this.auth.error && this.auth.AccessToken) {
      // this.$router.push('/otp-verification')
      // }
    },
  },
}
</script>

<style scoped>
@import '@/styles/login.css';
</style>
